// KABELUL static demo data — realistic Indonesian technical professional ecosystem
export const idr = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0).replace(/\s/g, " ");
export const shortIdr = (n) => {
  const v = n || 0;
  if (v >= 1_000_000_000) return `Rp ${(v / 1_000_000_000).toFixed(1).replace(".", ",")} M`;
  if (v >= 1_000_000) return `Rp ${(v / 1_000_000).toFixed(1).replace(".", ",")} jt`;
  return idr(v);
};

export const PROFILE = {
  id: "prof-budi-santoso",
  name: "Budi Santoso",
  title: "Field Network & Security Technician",
  location: "Bandung, Jawa Barat",
  photo: "https://images.unsplash.com/photo-1615109398623-88346a601842?w=400&h=400&fit=crop&crop=faces",
  tier: "Certified Professional",
  tierLevel: 3,
  tierMax: 5,
  rating: 4.8,
  reviews: 47,
  completedJobs: 47,
  memberSince: "March 2022",
  passportId: "KBL-ID-2022-08421",
  verified: true,
  bio: "Six years installing enterprise CCTV, fiber optic backbones, and structured cabling across Java. BNSP certified. Prefer field assignments in Jabodetabek and Bandung region.",
  languages: ["Bahasa Indonesia", "English (Working)"],
  hourlyRate: 185000,
  availability: "Available from 26 Aug 2026",
  skills: [
    { name: "CCTV Installation & Configuration", level: "Advanced", verified: true, endorsements: 32 },
    { name: "Fiber Optic Splicing (Level 2)", level: "Certified", verified: true, endorsements: 24 },
    { name: "Network Cabling CAT6 / CAT6A", level: "Expert", verified: true, endorsements: 41 },
    { name: "IP Networking Fundamentals", level: "Advanced", verified: true, endorsements: 27 },
    { name: "Hikvision NVR & VMS", level: "Certified", verified: true, endorsements: 18 },
    { name: "LV Electrical & K3 Safety", level: "Intermediate", verified: false, endorsements: 9, inProgress: true },
  ],
  certifications: [
    { title: "BNSP Teknisi Jaringan Komputer", issuer: "BNSP Indonesia", year: 2023, id: "BNSP/TJK/2023/00841", verified: true },
    { title: "Hikvision Certified Security Associate", issuer: "Hikvision Academy", year: 2024, id: "HCSA-2024-ID-3391", verified: true },
    { title: "CCTV Level 2 — Ministry Endorsed", issuer: "Kementerian Ketenagakerjaan RI", year: 2023, id: "MOL/CCTV2/23/12007", verified: true },
    { title: "Fiber Optic Splicing Level 2", issuer: "KABELUL Learning + LSP Telematika", year: 2024, id: "KBL-FO-L2-24-0821", verified: true },
  ],
};

export const AI_MATCHING = {
  eligible: 12,
  applied: 3,
  invitesReceived: 5,
  potentialIfLearn: [
    { skill: "Network Security Essentials", unlocks: 5 },
    { skill: "Fire Alarm & Life Safety", unlocks: 3 },
    { skill: "Fiber Optic Level 3 (OTDR Diagnostics)", unlocks: 4 },
  ],
};

export const OPPORTUNITIES = [
  {
    id: "op-001",
    title: "CCTV Installation Technician — 42 Camera Retail Store",
    company: "PT Sentosa Retail Group",
    companyInitials: "SR",
    tone: "emerald",
    location: "Jakarta Selatan",
    type: "Individual Job",
    duration: "5 working days",
    startDate: "2026-08-31",
    budget: 4200000,
    budgetUnit: "per project",
    posted: "2 hours ago",
    applicants: 8,
    eligible: true,
    matchScore: 94,
    requiredSkills: ["CCTV Installation & Configuration", "Network Cabling CAT6 / CAT6A", "Hikvision NVR & VMS"],
    missingSkills: [],
    aiReason: "You match all 3 required skills. Your Hikvision certification and 32 completed CCTV jobs give you a strong edge on this project.",
    description: "Deploy 42 IP cameras across new flagship retail store, terminate CAT6A backbone, configure NVR and remote monitoring.",
  },
  {
    id: "op-002",
    title: "Fiber Optic Splicing Specialist — Metro Backbone Extension",
    company: "PT Serat Nusantara",
    companyInitials: "SN",
    tone: "blue",
    location: "Bandung",
    type: "Freelance",
    duration: "3 weeks",
    startDate: "2026-09-02",
    budget: 12500000,
    budgetUnit: "per project",
    posted: "1 day ago",
    applicants: 4,
    eligible: true,
    matchScore: 91,
    requiredSkills: ["Fiber Optic Splicing (Level 2)", "Network Cabling CAT6 / CAT6A"],
    missingSkills: [],
    aiReason: "Fully eligible. Your BNSP + KABELUL fiber optic Level 2 cert directly matches. Location match: Bandung.",
    description: "Splicing 24-core single-mode backbone across 6 access points. OTDR test reports required.",
  },
  {
    id: "op-003",
    title: "Network Engineer — Data Center Jababeka",
    company: "PT Nusa Digital Infra",
    companyInitials: "ND",
    tone: "emerald",
    location: "Cikarang, Bekasi",
    type: "Project-based",
    duration: "6 weeks",
    startDate: "2026-09-07",
    budget: 42500000,
    budgetUnit: "per project",
    posted: "4 hours ago",
    applicants: 12,
    eligible: true,
    matchScore: 82,
    requiredSkills: ["IP Networking Fundamentals", "Network Cabling CAT6 / CAT6A"],
    missingSkills: [],
    aiReason: "Eligible on all mandatory requirements. Complete Network Security Essentials to become a stronger candidate for team-lead roles.",
    description: "Rack & stack, structured cabling, VLAN configuration for two new server rooms.",
  },
  {
    id: "op-004",
    title: "Field Engineer — POS & Network Rollout (Retail)",
    company: "PT Retail Digital Indo",
    companyInitials: "RD",
    tone: "amber",
    location: "Jakarta, Depok, Bekasi (Multi-site)",
    type: "Individual Job",
    duration: "3 weeks (rolling)",
    startDate: "2026-08-25",
    budget: 8400000,
    budgetUnit: "per project",
    posted: "6 hours ago",
    applicants: 6,
    eligible: true,
    matchScore: 88,
    requiredSkills: ["Network Cabling CAT6 / CAT6A", "IP Networking Fundamentals"],
    missingSkills: [],
    aiReason: "You match all core skills. 12 similar retail deployments in your history make this a natural fit.",
    description: "Rollout POS terminals and cabling across 14 retail sites in Jabodetabek.",
  },
  {
    id: "op-005",
    title: "Freelance CCTV Maintenance Contract",
    company: "PT Grha Pertokoan Bandung",
    companyInitials: "GP",
    tone: "blue",
    location: "Bandung",
    type: "Freelance (Recurring)",
    duration: "6 months contract",
    startDate: "2026-09-01",
    budget: 3200000,
    budgetUnit: "per month",
    posted: "Yesterday",
    applicants: 3,
    eligible: true,
    matchScore: 96,
    requiredSkills: ["CCTV Installation & Configuration", "Hikvision NVR & VMS"],
    missingSkills: [],
    aiReason: "Highest match this week. Recurring contract, close to your home city, matches your top verified skills.",
    description: "Monthly preventive maintenance for 6 tenants across two shopping centers.",
  },
  {
    id: "op-006",
    title: "Security System Integrator — Access Control + Fire Alarm",
    company: "PT Aman Sentosa Group",
    companyInitials: "AS",
    tone: "amber",
    location: "Surabaya",
    type: "Project-based",
    duration: "8 weeks",
    startDate: "2026-09-14",
    budget: 65000000,
    budgetUnit: "per project",
    posted: "3 days ago",
    applicants: 9,
    eligible: false,
    matchScore: 62,
    requiredSkills: ["CCTV Installation & Configuration", "Fire Alarm & Life Safety", "Access Control Systems"],
    missingSkills: ["Fire Alarm & Life Safety", "Access Control Systems"],
    aiReason: "You match 1 of 3 required skills. Completing KABELUL Fire Alarm & Life Safety course would unlock this and 2 similar opportunities.",
    description: "Integrated security system for a 12-floor commercial tower.",
  },
  {
    id: "op-007",
    title: "Data Center Cabling Team Lead",
    company: "PT Bumi Nusantara Tech",
    companyInitials: "BN",
    tone: "blue",
    location: "Cikarang, Bekasi",
    type: "Project-based",
    duration: "10 weeks",
    startDate: "2026-10-05",
    budget: 78000000,
    budgetUnit: "per project",
    posted: "5 days ago",
    applicants: 14,
    eligible: false,
    matchScore: 71,
    requiredSkills: ["Network Cabling CAT6 / CAT6A", "TIA-942 Certified", "Team Leadership"],
    missingSkills: ["TIA-942 Certified", "Team Leadership"],
    aiReason: "Strong technical match, but team-lead certification and TIA-942 required. Consider KABELUL Team Lead track (available May 2026).",
    description: "Lead a 6-person cabling team through TIA-942 compliant rollout.",
  },
  {
    id: "op-008",
    title: "High Voltage Electrical Technician",
    company: "PT Energi Prima",
    companyInitials: "EP",
    tone: "amber",
    location: "Semarang",
    type: "Individual Job",
    duration: "2 weeks",
    startDate: "2026-09-21",
    budget: 6800000,
    budgetUnit: "per project",
    posted: "1 week ago",
    applicants: 5,
    eligible: false,
    matchScore: 41,
    requiredSkills: ["HV Electrical Certification", "K3 Listrik (High Voltage)"],
    missingSkills: ["HV Electrical Certification", "K3 Listrik (High Voltage)"],
    aiReason: "Different specialization. Consider expanding into LV first (already in progress) before high-voltage track.",
    description: "HV substation maintenance requiring specialized certification.",
  },
];

export const COURSES = [
  {
    id: "c-01",
    title: "IP Networking Fundamentals",
    provider: "KABELUL Learning + LSP Telematika",
    duration: "18 hours",
    modules: 8,
    progress: 100,
    status: "Completed",
    completedOn: "12 Aug 2023",
    unlocks: 4,
    tag: "Networking",
    tone: "emerald",
    certified: true,
    description: "TCP/IP, subnetting, VLAN, routing basics with 12 hands-on labs.",
  },
  {
    id: "c-02",
    title: "Fiber Optic Splicing — Level 2",
    provider: "KABELUL Learning",
    duration: "22 hours",
    modules: 10,
    progress: 100,
    status: "Completed",
    completedOn: "04 Feb 2024",
    unlocks: 3,
    tag: "Fiber Optic",
    tone: "emerald",
    certified: true,
    description: "Fusion splicing, OTDR, single-mode and multi-mode. Certified by LSP Telematika.",
  },
  {
    id: "c-03",
    title: "CCTV Advanced — H.265+ & Video Analytics",
    provider: "Hikvision Academy × KABELUL",
    duration: "16 hours",
    modules: 7,
    progress: 65,
    status: "In Progress",
    unlocks: 2,
    tag: "Security",
    tone: "amber",
    certified: false,
    description: "Advanced NVR configuration, ANPR, people counting, HTTPS streaming.",
    nextLesson: "Module 5 — People Counting Analytics",
  },
  {
    id: "c-04",
    title: "LV Electrical & K3 Safety",
    provider: "PLN Corporate University × KABELUL",
    duration: "24 hours",
    modules: 12,
    progress: 40,
    status: "In Progress",
    unlocks: 3,
    tag: "Electrical",
    tone: "amber",
    certified: false,
    description: "Panel installation, grounding, K3 workplace safety, PUIL 2011 essentials.",
    nextLesson: "Module 5 — Grounding & Bonding",
  },
  {
    id: "c-05",
    title: "Network Security Essentials",
    provider: "KABELUL Learning",
    duration: "14 hours",
    modules: 6,
    progress: 0,
    status: "Not Started",
    unlocks: 5,
    tag: "Networking",
    tone: "blue",
    certified: false,
    description: "Firewall basics, VPN, intrusion prevention. Unlocks 5 network engineer opportunities.",
    recommended: true,
    reason: "Top recommendation — unlocks the most opportunities for your skill profile.",
  },
  {
    id: "c-06",
    title: "Fire Alarm & Life Safety Systems",
    provider: "KABELUL Learning + Damkar Jakarta",
    duration: "20 hours",
    modules: 9,
    progress: 0,
    status: "Not Started",
    unlocks: 3,
    tag: "Safety",
    tone: "blue",
    certified: false,
    description: "SNI 03-3985 compliance, addressable panels, integration with CCTV/Access Control.",
    recommended: true,
    reason: "Pairs well with your CCTV specialization — a natural next step.",
  },
  {
    id: "c-07",
    title: "Fiber Optic Level 3 — OTDR Diagnostics",
    provider: "LSP Telematika × KABELUL",
    duration: "26 hours",
    modules: 11,
    progress: 0,
    status: "Not Started",
    unlocks: 4,
    tag: "Fiber Optic",
    tone: "blue",
    certified: false,
    description: "Advanced OTDR trace analysis, chromatic dispersion, PON troubleshooting.",
  },
  {
    id: "c-08",
    title: "Team Lead Track — Project Field Ops",
    provider: "KABELUL Learning",
    duration: "12 hours",
    modules: 6,
    progress: 0,
    status: "Coming Soon",
    unlocks: 6,
    tag: "Leadership",
    tone: "gray",
    certified: false,
    description: "Site supervision, safety briefings, client reporting, subcontractor coordination.",
  },
];

export const TALENT = [
  {
    id: "t-01",
    name: "Budi Santoso",
    title: "Field Network & Security Technician",
    location: "Bandung",
    tier: "Certified Professional",
    rating: 4.8,
    reviews: 47,
    completed: 47,
    skills: ["CCTV", "Fiber Optic L2", "Network Cabling"],
    verified: true,
    photo: "https://images.unsplash.com/photo-1615109398623-88346a601842?w=400&h=400&fit=crop&crop=faces",
    availability: "Available 26 Aug",
    rate: 185000,
    matchScore: 96,
    isSelf: true,
  },
  {
    id: "t-02",
    name: "Ari Wibowo",
    title: "Network Engineer",
    location: "Surabaya",
    tier: "Expert",
    rating: 4.9,
    reviews: 62,
    completed: 62,
    skills: ["Cisco CCNP", "MikroTik", "Data Center"],
    verified: true,
    photo: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=400&h=400&fit=crop&crop=faces",
    availability: "Available now",
    rate: 275000,
    matchScore: 92,
  },
  {
    id: "t-03",
    name: "Siti Rahmawati",
    title: "Fiber Optic Splicing Specialist",
    location: "Yogyakarta",
    tier: "Certified Professional",
    rating: 4.7,
    reviews: 34,
    completed: 34,
    skills: ["Fiber Optic L3", "OTDR", "PON Networks"],
    verified: true,
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces",
    availability: "Available 03 Sep",
    rate: 210000,
    matchScore: 88,
  },
  {
    id: "t-04",
    name: "Rizki Adiputra",
    title: "CCTV & Access Control Engineer",
    location: "Jakarta Timur",
    tier: "Expert",
    rating: 4.8,
    reviews: 71,
    completed: 71,
    skills: ["Hikvision", "Access Control", "Analytics"],
    verified: true,
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=faces",
    availability: "Available now",
    rate: 240000,
    matchScore: 90,
  },
  {
    id: "t-05",
    name: "Dewi Purnama",
    title: "Data Center Technician",
    location: "Cikarang",
    tier: "Certified Professional",
    rating: 4.6,
    reviews: 28,
    completed: 28,
    skills: ["Rack & Stack", "Structured Cabling", "TIA-942"],
    verified: true,
    photo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop&crop=faces",
    availability: "Available 12 Sep",
    rate: 225000,
    matchScore: 85,
  },
  {
    id: "t-06",
    name: "Andi Kusuma",
    title: "LV Electrical & Panel Technician",
    location: "Bandung",
    tier: "Certified",
    rating: 4.5,
    reviews: 19,
    completed: 19,
    skills: ["LV Panel", "K3 Listrik", "PUIL 2011"],
    verified: true,
    photo: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=400&fit=crop&crop=faces",
    availability: "Available now",
    rate: 170000,
    matchScore: 78,
  },
];

export const REPUTATION = {
  overall: 4.8,
  reviewCount: 47,
  breakdown: {
    "5": 39,
    "4": 6,
    "3": 2,
    "2": 0,
    "1": 0,
  },
  metrics: [
    { label: "On-time delivery", value: 96, note: "45 of 47 jobs on time" },
    { label: "Communication", value: 94, note: "Highly responsive" },
    { label: "Technical quality", value: 98, note: "Zero rework in last 20 jobs" },
    { label: "Safety compliance", value: 100, note: "K3 checklist adherence" },
  ],
  reviews: [
    {
      id: "r-01",
      client: "PT Sentosa Retail Group",
      clientInitials: "SR",
      tone: "emerald",
      job: "42-Camera CCTV Deployment — Flagship Store",
      rating: 5,
      date: "28 Jul 2026",
      comment: "Delivered a day early, cabling was clean, and gave us a proper handover document. Will hire again for our other 4 stores.",
      badges: ["Excellent quality", "On-time", "Great communication"],
    },
    {
      id: "r-02",
      client: "PT Nusa Digital Infra",
      clientInitials: "ND",
      tone: "blue",
      job: "Fiber Splicing — 12-core Backbone Cikarang",
      rating: 5,
      date: "14 Jul 2026",
      comment: "OTDR reports were exactly per spec. Followed safety procedures throughout. Recommended.",
      badges: ["Technical excellence", "Safety first"],
    },
    {
      id: "r-03",
      client: "PT Grha Pertokoan Bandung",
      clientInitials: "GP",
      tone: "amber",
      job: "CCTV Preventive Maintenance — Q2 2026",
      rating: 5,
      date: "30 Jun 2026",
      comment: "Reliable, punctual, and proactively flagged an NVR issue before it became a problem.",
      badges: ["Proactive", "Reliable"],
    },
    {
      id: "r-04",
      client: "PT Retail Digital Indo",
      clientInitials: "RD",
      tone: "emerald",
      job: "POS Rollout — 8 Jabodetabek sites",
      rating: 4,
      date: "18 Jun 2026",
      comment: "Solid work overall. One site cabling had a minor label mismatch but was corrected quickly.",
      badges: ["Good communication"],
    },
  ],
  timeline: [
    { period: "Aug 2026", jobs: 2, earnings: 8600000 },
    { period: "Jul 2026", jobs: 5, earnings: 21400000 },
    { period: "Jun 2026", jobs: 4, earnings: 18200000 },
    { period: "May 2026", jobs: 5, earnings: 21600000 },
    { period: "Apr 2026", jobs: 4, earnings: 16800000 },
    { period: "Mar 2026", jobs: 3, earnings: 11500000 },
  ],
};

export const DASHBOARD_STATS = {
  learningProgress: 62,
  activeCourses: 2,
  completedCourses: 2,
  verifiedSkills: 5,
  reputationScore: 4.8,
  reputationJobs: 47,
  potentialEarnings: 47800000,
};
